/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-bootstrap/dropdown/bs-dropdown-container.component';
import * as import2 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
const styles_BsDropdownContainerComponent:any[] = ([] as any[]);
export const RenderType_BsDropdownContainerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_BsDropdownContainerComponent,
  data: {}
}
);
export function View_BsDropdownContainerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),[
      [
        2,
        'dropup',
        (null as any)
      ]
      ,
      [
        2,
        'dropdown',
        (null as any)
      ]
      ,
      [
        2,
        'show',
        (null as any)
      ]
      ,
      [
        2,
        'open',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.BsDropdownContainerComponent = v.component;
    const currVal_0:any = (co.direction === 'up');
    const currVal_1:any = (co.direction === 'down');
    const currVal_2:any = co.isOpen;
    const currVal_3:any = co.isOpen;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  });
}
function View_BsDropdownContainerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'bs-dropdown-container',[[
        'style',
        'display:block;position: absolute;'
      ]
    ],(null as any),(null as any),(null as any),View_BsDropdownContainerComponent_0,RenderType_BsDropdownContainerComponent)),
    import0.ɵdid(90112,(null as any),0,import1.BsDropdownContainerComponent,[
      import2.BsDropdownState,
      import0.ChangeDetectorRef,
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const BsDropdownContainerComponentNgFactory:import0.ComponentFactory<import1.BsDropdownContainerComponent> = import0.ɵccf('bs-dropdown-container',import1.BsDropdownContainerComponent,View_BsDropdownContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3RtcC9zd2lmdC1idWlsZC9wcm9kL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL2Ryb3Bkb3duL2JzLWRyb3Bkb3duLWNvbnRhaW5lci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdG1wL3N3aWZ0LWJ1aWxkL3Byb2Qvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvZHJvcGRvd24vYnMtZHJvcGRvd24tY29udGFpbmVyLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vdG1wL3N3aWZ0LWJ1aWxkL3Byb2Qvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvZHJvcGRvd24vYnMtZHJvcGRvd24tY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLkJzRHJvcGRvd25Db250YWluZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL3RtcC9zd2lmdC1idWlsZC9wcm9kL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL2Ryb3Bkb3duL2JzLWRyb3Bkb3duLWNvbnRhaW5lci5jb21wb25lbnQuZC50cy5Cc0Ryb3Bkb3duQ29udGFpbmVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdiBbY2xhc3MuZHJvcHVwXT1cImRpcmVjdGlvbiA9PT0gJ3VwJ1wiXG4gICAgICAgICBbY2xhc3MuZHJvcGRvd25dPVwiZGlyZWN0aW9uID09PSAnZG93bidcIlxuICAgICAgICAgW2NsYXNzLnNob3ddPVwiaXNPcGVuXCJcbiAgICAgICAgIFtjbGFzcy5vcGVuXT1cImlzT3BlblwiPjxuZy1jb250ZW50PjwvbmctY29udGVudD48L2Rpdj5cbiAgIiwiPGJzLWRyb3Bkb3duLWNvbnRhaW5lcj48L2JzLWRyb3Bkb3duLWNvbnRhaW5lcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO0lBQ0k7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBRzJCO0lBQStCOzs7O0lBSHJEO0lBQ0E7SUFDQTtJQUNBO0lBSEwsU0FBSyxVQUNBLFVBQ0EsVUFDQSxTQUhMOzs7OztNQ0RKO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/ngx-bootstrap/dropdown/bs-dropdown-container.component.ngfactory.ts